import { useUserStoreWithOut } from '@/store/modules/user';
import { authPermission } from '@/utils/permission'
import { ensureUserProfileInitialized } from '@/utils/userProfile'

const LOGIN_PATH = '/login'
const BASE_PATH = '/ipt'
const whitePathList = [LOGIN_PATH]

export default (router) => {
  const userStore = useUserStoreWithOut();

  router.beforeEach(async (to, from, next) => {
    const routes = router.getRoutes()
    let token = localStorage.getItem('token')
    const permissions = userStore.getPermission
    if (to.query?.tid && to.query?.tid !== token) {
      userStore.setToken(to.query.tid)
      token = to.query.tid
      ensureUserProfileInitialized().catch(() => {})
    }
    
    if (whitePathList.includes(to.path)) {
      if (to.path === LOGIN_PATH && token) {
        try {
          await userStore.getUserInfoAction();
          await ensureUserProfileInitialized().catch(() => {})
          next({ path: BASE_PATH, replace: true })
        } catch (error) {
          next()
        }
        return
      }
      next()
      return
    }

    if (!routes.find(v => v.path === to.path)) {
      next({ path: '/404', replace: true })
      return
    }

    console.log(router.getRoutes(), permissions, to.meta.permissions)

    if (!token) {
      next({ path: LOGIN_PATH, replace: true })
      return
    }

    if (!userStore.getUserInfo) {
      try {
        await userStore.getUserInfoAction();
        await ensureUserProfileInitialized().catch(() => {})
      } catch (err) {
        next();
        return;
      }
    }

    if (to.meta.permissions && !authPermission(to.meta.permissions)) {
      next({ path: '/401', replace: true })
      return
    }
    next()
  })
}
